<style scoped>
.this__block {
  width: 40px;
  height: 40px;
  border-radius: 5px;
  text-transform: uppercase;
  text-align: center;
  color: white;
  line-height: 40px;
  font-size: 16px;
  font-weight: 500;
}
.this__width {
  width: 78.05px;
  text-align: center;
}
.this__verifyIcon {
  position: relative;
  top: 11px;
  right: 53px;
}
</style>
<template>
  <div
    class="demo__flex demo__flex-middle demo__font--16 demo__weight--500 demo__pointer"
    v-if="user"
  >
    <a-popover
      :title="false"
      :footer="false"
      overlayClassName="demo__logout-overlay"
      placement="bottomRight"
      trigger="click"
    >
      <template slot="content">
        <div class="demo__flex demo__flex-column demo__gap--8 demo__width--268">
          <div
            class="demo__flex demo__flex-row demo__padding-top--16 demo__padding-right--8 demo__padding-bottom--16 demo__padding-left--0"
          >
            <img
              :src="
                require('@/assets/images/icons/' +
                  (this.user?.plan?.subscription_plan !== 1
                    ? 'subscriber'
                    : 'user') +
                  '.svg')
              "
              class="m-r"
            />
            <div
              class="demo__flex demo__flex-column demo__pointer"
              @click="goToLk"
            >
              <h3
                class="demo__font--16 demo__weight--600 demo__margin-bottom--0 demo__color--white demo__width-hug"
              >
                {{ fio[0] }} {{ fio[1] }}
              </h3>
              <p
                class="demo__font--14 demo__weight--400 demo__margin-auto demo__width--198 demo__text-wrap"
              >
                {{ this.user?.email }}
              </p>
            </div>
          </div>
          <div
            class="demo__flex demo__font--16 demo__weight--500 demo__flex-middle demo__pointer this__width"
            @click="goToLk"
          >
            {{ $t("Profile") }}
          </div>
          <div
            class="demo__flex demo__font--16 demo__weight--500 demo__flex-middle demo__pointer this__width"
            v-if="
              this.user?.plan?.subscription_plan === 1 && this.$root.showLogic
            "
            @click="$router.push('/subscriptions')"
          >
            {{ $t("Subscription") }}
          </div>
          <div
            class="demo__flex demo__font--16 demo__weight--500 demo__flex-middle demo__pointer"
            @click="logoutUser()"
          >
            <div>
              {{ $t("Exit") }}
            </div>
            <div>
              <i class="m-l dash-icon fa-light fa-arrow-right-from-bracket" />
            </div>
          </div>
        </div>
      </template>
      <div class="demo__flex demo__flex-middle">
        <!-- <div class="demo__font--16 demo__weight--500 demo__color--white demo__margin-right--10" v-if="fullNameShort">
        {{ fullNameShort }}
      </div> -->
        <div class="this__block demo__bg--bgSecondary">
          {{ initials }}
        </div>
        <img
          v-if="isVerifyEnabled"
          :src="verifyIcon"
          class="this__verifyIcon"
        />
      </div>
    </a-popover>
  </div>
  <AuthLockBlock ym_location="header" v-else>
    <a-button class="demo__button demo__button--base">
      <span>
        {{ $t("Submit") }}
      </span>
      <i class="fa-light fa-chevron-right demo__margin-left--12"></i>
    </a-button>
  </AuthLockBlock>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      checkVerifyIcon: require("@/assets/images/icons/checkCircleGrey.svg"),
      verifiedIcon: require("@/assets/images/icons/checkCircleRed.svg"),
      badVerifiedIcon: require("@/assets/images/icons/crossCircleRed.svg"),
    };
  },
  computed: {
    ...mapGetters(["api", "user"]),
    isVerifyEnabled() {
      return this.verifyIcon && process.env.VUE_APP_VERIFY === "on";
    },
    initials() {
      return this.fio.length >= 2
        ? (this.fio[0][0] + this.fio[1][0]).replace("undefined", "")
        : this.$t("MY");
    },
    verifyIcon() {
      if (!this.user?.profstat_verified) {
        if (this.user?.current_verification?.status === "processing") {
          return this.checkVerifyIcon;
        } else if (this.user?.current_verification?.status === "rejected") {
          return this.badVerifiedIcon;
        } else return undefined;
      }
      return this.verifiedIcon;
    },
    fio() {
      return this.user?.fullName?.split
        ? this.user?.fullName?.replace("  ", "").split(" ")
        : [];
    },
    fullNameShort() {
      return this.fio.length
        ? this.fio[0].length < 20
          ? this.parseFio(this.fio[0]) +
            " " +
            this.parseFio(this.fio[1], true) +
            this.parseFio(this.fio[2], true)
          : this.parseFio(this.fio[0].slice(0, 20)) + "..."
        : undefined;
    },
  },
  mounted() {
    this.$accessModule("lk1", this);
  },
  methods: {
    goToLk() {
      if (this.$route.path !== "/lk") {
        this.$router.push("/lk");
      }
    },
    logoutUser() {
      this.$store.dispatch("logoutUser");
      this.$root.$emit("stopUserUpdate");
    },
    parseFio(fio, short) {
      return fio ? (short ? fio.slice(0, 1) + "." : fio) : "";
    },
  },
};
</script>
